import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "asCourseProgress" }
const _hoisted_2 = { class: "asCourseProgress_row" }
const _hoisted_3 = { class: "asCourseProgress_text" }
const _hoisted_4 = { class: "asCourseProgress_line" }
const _hoisted_5 = { class: "asCourseProgress_row" }
const _hoisted_6 = { class: "asCourseProgress_text" }
const _hoisted_7 = { class: "asCourseProgress_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.videoCount) + " " + _toDisplayString(_ctx.$t('videoLessons')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "asCourseProgress_fill",
        style: _normalizeStyle({ width: `${_ctx.progress}%` })
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('progressLesson')), 1),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.progress) + "%", 1)
    ])
  ]))
}